/* Shopify localization handles the price, cart and checkout currency together. */
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-hr-currency]')) event.target.form.requestSubmit();
});
document.addEventListener('click', (event) => {
  const swatch = event.target.closest('[data-hr-swatch]');
  if (!swatch || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
  const card = swatch.closest('[data-hr-product]');
  if (!card) return;
  event.preventDefault();
  card.querySelectorAll('[data-hr-swatch]').forEach((item) => {
    item.classList.toggle('is-selected', item === swatch);
    item.setAttribute('aria-current', String(item === swatch));
  });
  card.querySelectorAll('[data-hr-product-link]').forEach((link) => { link.href = swatch.href; });
  const image = card.querySelector('.hr-product__image');
  if (image && swatch.dataset.image) {
    image.removeAttribute('srcset');
    image.src = swatch.dataset.image;
    image.alt = `${card.querySelector('.hr-product__title').textContent.trim()} — ${swatch.title}`;
  }
  card.querySelector('[data-hr-price]').textContent = swatch.dataset.price;
  const compare = card.querySelector('[data-hr-compare]');
  compare.textContent = swatch.dataset.compare;
  compare.hidden = !swatch.dataset.compare;
  const saving = card.querySelector('[data-hr-saving]');
  saving.textContent = swatch.dataset.saving;
  saving.hidden = !swatch.dataset.saving;
});
